import { Col, Row } from "react-bootstrap";
import { Button, Link } from "stories";
import profileData from "../profileData.js";
import ProfileInfoItem from "../profileInfoItem/ProfileInfoItem";
import classes from "./ProfileInfo.module.scss";

const ProfileInfo = ({ getProfileResponse, setEditMode }) => {
  return (
    <>
      <Row>
        {profileData.map((item, index) => (
          <Col sm={12} md={6} key={index}>
            <ProfileInfoItem
              label={item.label}
              value={getProfileResponse[item.name]}
            />
          </Col>
        ))}
      </Row>
      <div className={classes["button-wrapper"]}>
        <div className={classes["link"]}>
          <Link to={"./change-password"} inherit>
            Change Password
          </Link>
        </div>
        <Button
          label={"Edit Account Information"}
          onClick={() => setEditMode(true)}
        />
      </div>
    </>
  );
};

export default ProfileInfo;
